import { createStore, applyMiddleware, compose } from 'redux';

export function createMainStore(shouldAddDebug, debugName, initialState = {}, reducer, arrMiddlewares = []) {
  const composeEnhancers =
    typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        name: debugName
      })
      : compose;
  const middleware = arrMiddlewares.concat([]);
  const composer = shouldAddDebug ? composeEnhancers : compose;
  const store = createStore(reducer, initialState, composer(applyMiddleware(...middleware)));
  return store;
}
